import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateDivision } from "~pages/Divisions/types/upsertDivision.ts";
import type { DivisionResponse } from "~types/division.ts";

export const useCreateDivision = () => {
  const { sport, organizationId, conferenceId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DivisionResponse | undefined, Error, CreateDivision>({
    mutationFn: async (data) => {
      return await request<DivisionResponse>(`${sport}/o/${organizationId}/conferences/${conferenceId}/divisions`, {
        method: "POST",
        body: data,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["divisions"] });
    },
  });
};
